import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { BRAND, BRAND_SUB, TAGLINE } from "@/lib/constants";

export const Footer = () => (
  <footer className="bg-[#121417] text-[#FAF9F6] mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <p className="font-display text-3xl">{BRAND} <span className="text-[#C5A46A] italic">{BRAND_SUB}</span></p>
        <p className="mt-3 font-display italic text-lg text-[#E2C58F]" data-testid="footer-tagline">{TAGLINE}</p>
        <p className="mt-4 text-sm text-[#B9B4AA] max-w-sm leading-relaxed">
          A private, chain-free property service for ready buyers and motivated sellers across London and Greater London.
        </p>
      </div>
      <div className="md:col-span-3 space-y-3 text-sm">
        <p className="eyebrow !text-[#C5A46A]">Explore</p>
        <Link to="/properties" className="block text-[#D9D5CC] hover:text-white">Available properties</Link>
        <Link to="/completed" className="block text-[#D9D5CC] hover:text-white">Completed deals</Link>
        <Link to="/buy" className="block text-[#D9D5CC] hover:text-white">Register as a buyer</Link>
        <Link to="/sell" className="block text-[#D9D5CC] hover:text-white">Sell your property</Link>
      </div>
      <div className="md:col-span-4 text-sm">
        <p className="eyebrow !text-[#C5A46A]">Confidentiality</p>
        <p className="mt-3 flex gap-3 text-[#D9D5CC] leading-relaxed">
          <ShieldCheck className="h-5 w-5 shrink-0 text-[#C5A46A]" />
          Buyers and sellers never see each other's personal details. Every introduction is handled by us.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="max-w-7xl mx-auto px-6 sm:px-10 py-6 font-plex text-xs text-[#8F8A80]">
        © {new Date().getFullYear()} {BRAND} {BRAND_SUB}. All rights reserved.
      </p>
    </div>
  </footer>
);
